import { BaseService } from './BaseService.js';

/**
 * Content Service
 * Handles CMS content using Laravel API
 */
export class ContentService extends BaseService {
  constructor() {
    super('content'); // Laravel endpoint: /api/content
  }

  /**
   * Get content by section or page
   * @param {string} section - Content section or page name
   * @returns {Promise<Array>} Section content
   */
  async getBySection(section) {
    return this.list(1, 50, { section });
  }
  
  /**
   * Override list method to handle page parameter for content
   */
  async list(page = 1, limit = 50, filters = {}) {
    // If page is string, treat it as page filter for content
    if (typeof page === 'string') {
      return super.list(1, 50, { page, ...filters });
    }
    return super.list(page, limit, filters);
  }

  /**
   * Get content by key
   * @param {string} key - Content key
   * @returns {Promise<Object|null>} Content item
   */
  async getByKey(key) {
    return this.customCall(`key/${key}`);
  }

  /**
   * Update homepage content
   * @param {Object} data - Homepage content data
   * @returns {Promise<Object>} Updated homepage content
   */
  async updateHomepage(data) {
    return this.customCall('homepage', 'PUT', data);
  }

  /**
   * Get all content grouped by section
   * @returns {Promise<Array>} All content grouped by section
   */
  async getAllGrouped() {
    return this.customCall('grouped');
  }

  /**
   * Get landing page content
   * @returns {Promise<Object>} Landing page content
   */
  async getLandingPageContent() {
    return this.customCall('landing-page');
  }

  /**
   * Update content by key
   * @param {string} key - Content key
   * @param {Object} data - Content data
   * @returns {Promise<Object>} Updated content
   */
  async updateByKey(key, data) {
    return this.customCall(`key/${key}`, 'PUT', data);
  }
}

// Export singleton instance for backward compatibility
const contentService = new ContentService();
export default contentService; 